<div class="eau-loader-btn-wrap">
    <ng-content></ng-content>
    <eau-loader-spinner [inline]="true" *ngIf="shouldShowLoader"></eau-loader-spinner>
</div>
